import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';

import DefaultBanner from '../../../components/DefaultBanner';

import {
  Grid,
  Row,
  Col,
} from '../../../incubation/components/ResponsiveGridLayout';

import Link from '../../../components/Link';

import s from './SunWellness.scss';

class SunWellness extends React.Component {
  render() {
    return (
      <React.Fragment>
        <DefaultBanner
          breadcrumb={
            <ul
              className="breadcrumb"
              itemScope
              itemType="https://schema.org/BreadcrumbList"
            >
              <li
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <Link
                  itemProp="item"
                  itemType="https://schema.org/Thing"
                  to="/"
                >
                  <span itemProp="name">Home</span>
                </Link>
                <meta content="0" itemProp="position" />
              </li>
              <li
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <a
                  href="https://fluxtech.co/portfolio/"
                  itemProp="item"
                  itemType="https://schema.org/Thing"
                >
                  <span itemProp="name">Portfolio</span>
                  <meta content="1" itemProp="position" />
                </a>
              </li>
              <li>Sun Wellness</li>
            </ul>
          }
          header="Sun Wellness"
          subHeader="API based project"
        />
        <div className={s.sunWellness}>
          <Grid>
            <Row>
              <Col md={12}>
                <h4>About</h4>
                <p>
                  Located minutes from Garden of the Gods, downtown Manitou
                  Springs, and many other natural and historical Colorado
                  destinations, SunWater Spa and SunMountain Center are the
                  perfect destinations to include in your next getaway. As
                  creative sanctuaries for wellness, we appreciate and celebrate
                  the living arts through various workshops and events. A visit
                  with us is an opportunity to rest, replenish, and renew
                  yourself in a holistic manner as you discover beauty,
                  inspiration, and history around every corner.
                </p>
                <h4>Background</h4>
                <p>
                  Sun Wellness used Retreat Guru for all their client
                  reservations. They wanted an easier way for their staff to
                  access their booking schedule and so they tasked us with
                  solving this issue.
                </p>
                <h4>Solution</h4>
                <p>
                  We wrote a calendar syncing script that made requests to
                  Retreat Guru's API and then uploaded those bookings to Google
                  Calendar using Google's API. What was originally going to be a
                  very simple task became slightly more challenging when we
                  realized that Google didn't properly document their API. We
                  were able to quickly get around the poor documentation and
                  implement a working solution.
                </p>
                <div className={s.review}>
                  <img
                    alt="Justin Kovach"
                    src="/images/uncompressed/justin-kovach-square.jpg"
                  />
                  <blockquote>
                    "Our experience with Flux Tech was excellent. Incredible
                    responsiveness. Whenever an issue arose, it was resolved
                    amazingly quickly. Pleasant, professional and very easy to
                    work with."
                    <br />
                    <br />
                    <span>- Justin Kovach</span>
                  </blockquote>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(s)(SunWellness);
